<form novalidate nz-form [formGroup]="formGroup">
  <div nz-row [nzGutter]="24">
    <ng-container *ngFor="let field of formFields">
      <div [hidden]="field.isHide" nz-col [nzSpan]="field.colClass || colGroup" class="mb-2">
        <nz-form-item class="mb-0" id="{{field.field + '_' + currentTime}}">
          <nz-form-label *ngIf="field.label" [nzSpan]="field.labelCol || labelCol" class="text-start"
          >{{ field.label }}
            <span *ngIf="field.required" class="text-danger">*</span></nz-form-label>
          <nz-form-control [nzSpan]="field.controlCol || controlCol"  [nzErrorTip]="errorsTpl">
            <nz-input-group
              *ngIf="field.suffixIcon || (field.suffix && field.type != formItemType.RANGE_NUMBER ) || field.prefixIcon || field.prefix; else controlTpl"
              [nzPrefixIcon]="field.prefixIcon"
              [nzSuffix]="field.suffix"
              [nzPrefix]="field.prefix"
              [nzSuffixIcon]="field.suffixIcon"
            >
              <ng-container [ngTemplateOutlet]="controlTpl"></ng-container>
            </nz-input-group>
            <ng-template #controlTpl>
              <ng-container [ngSwitch]="field.type">
                <ng-container *ngSwitchCase="formItemType.CHECKBOX">
                  <label
                    nz-checkbox
                    [formControlName]="field.field"
                    [nzDisabled]="field.disable"
                  >
                  </label>
                </ng-container>
                <ng-container *ngSwitchCase="formItemType.INPUT_NUMBER">
                  <vss-ui-input-number
                    inputNumber
                    [class.hasSuffix]="field.suffixIcon || (field.suffix && field.type != formItemType.RANGE_NUMBER ) || field.prefixIcon || field.prefix"
                    class="w-100 text-start"
                    vssUiAutoCplControl
                    [vssUiAutocomplete]="field.field"
                    [disabledAutoComplete]="!!field?.disableAutocomplete"
                    [formControlName]="field.field"
                    [maxlength]="field?.maxLength || 4000"
                    [csPlaceHolder]="field.placeholder || field.label"
                  ></vss-ui-input-number>
<!--                  <input-->
<!--                    inputNumber-->
<!--                    class="w-100"-->
<!--                    nz-input-->
<!--                    type="text"-->
<!--                    vssUiAutoCplControl-->
<!--                    [vssUiAutocomplete]="field.field"-->
<!--                    [disabledAutoComplete]="!!field?.disableAutocomplete"-->
<!--                    [formControlName]="field.field"-->
<!--                    [maxlength]="field?.maxLength || 4000"-->
<!--                    [placeholder]="field.placeholder || field.label"-->
<!--                  />-->
                </ng-container>
                <ng-container
                  *ngSwitchCase="colDateTypes.includes(field.type) ? field.type : -1"
                >
                  <vss-ui-date-picker
                    dateFormat [ranges]="field.rangesDate"
                    [csDisable]="!!field.disable"
                    [formControlName]="field.field"
                    [csShowToday]="true"
                    [csRangePicker]="
          formItemType.DATE_RANGE_PICKER == field.type ||
          formItemType.DATE_TIME_RANGE_PICKER == field.type
        "
                    [csShowTime]="
          formItemType.DATE_TIME_RANGE_PICKER == field.type ||
          formItemType.DATE_TIME_PICKER == field.type
        "
                  ></vss-ui-date-picker>
                </ng-container>
                <ng-container *ngSwitchCase="formItemType.TAGS">
                  <nz-select [formControlName]="field.field" nzMode="tags" [nzPlaceHolder]="field.placeholder || ''">
                    <nz-option *ngFor="let option of field.options" [nzLabel]="option.label" [nzValue]="option.value"></nz-option>
                  </nz-select>
                </ng-container>
                <ng-container *ngSwitchCase="formItemType.SELECT">
                  <vss-ui-select-box

                    #csSelectScrollComponent
                    [formControlName]="field.field"
                    [optionList]="field.options || []"
                    [getOptionsApi]="field.apiSearch!"
                    [keySearch]="field.keySearch || 'keyword'"
                    addressSelector
                    [asType]="field.addressSelectorType!"
                    [asReferenceId]="field.referenceColName ? formGroup.get(field.referenceColName)?.value : null"
                    vssUiSelectDir
                    [selectOptionsQueryParams]="field.referenceColName ? (formGroup.get(field.referenceColName)?.value | parseObject : field.referenceColName) : null"
                    [selectOptionsType]="field.selectOptionsType!"
                    [csMaxTagCount]="field.csMaxTagCount!"
                    [params]="field.params!"
                    [csMode]="field.multiple ? 'multiple' : 'default'"
                    [csPlaceHolder]="field.placeholder || field.label"
                    [csAllowClear]="
                      field.csAllowClear !== undefined ? field.csAllowClear! : true
                    "
                    [csDropdownMatchSelectWidth]="true"
                  ></vss-ui-select-box>
                </ng-container>
                <ng-container *ngSwitchCase="formItemType.TEXTAREA">
                  <nz-textarea-count [nzMaxCharacterCount]="field.maxLength || MAX_LENGTH_TEXT">
                  <textarea
                    rows="4"
                    nz-input
                    [formControlName]="field.field"
                    [placeholder]="field.placeholder || field.label"
                    [attr.maxlength]="field.maxLength || MAX_LENGTH_TEXT"
                    #inputTextareaRef
                  ></textarea>
                  </nz-textarea-count>
                </ng-container>
                <ng-container *ngSwitchCase="formItemType.RANGE_NUMBER">
                  <vss-ui-range-number

                    [minValue]="field.minValue || 0"
                    [maxValue]="field.maxValue || 100"
                    [suffix]="field.suffix || ''"
                    [classes]="'text-right'"
                    [formControlName]="field.field"
                  ></vss-ui-range-number>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <input
                    type="text"
                    nz-input vssUiTrimSpaceInput
                    autofocus
                    [formControlName]="field.field"
                    [placeholder]="field.placeholder || field.label"
                    [attr.maxlength]="field.maxLength || MAX_LENGTH_TEXT"
                    vssUiAutoCplControl
                    [vssUiAutocomplete]="field.field"
                    #inputDefaultRef
                  />
                </ng-container>
              </ng-container>
            </ng-template>

          </nz-form-control>
        </nz-form-item>
      </div>
    </ng-container>
  </div>
</form>
<ng-template #errorsTpl let-control>
  <render-errors [data]="control"></render-errors>
</ng-template>
